import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import { Remove, Add } from '@material-ui/icons';
import { Box, IconButton, Typography } from '@material-ui/core'
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import { useTranslate } from 'react-admin';
import { useMediaQuery, makeStyles } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import CheckBox from '../checkbox'
import ExpandButton from '../CustomizedUIs/ExpandButton';
const useStyles = makeStyles(theme => ({
    iconButton: {
        borderRadius: '8px',
        padding: '2px'
    },

    iconButtonClose: {
        backgroundColor: '#e5f1f8',
        "&:hover": {
            backgroundColor: '#e5f1f8'
        },
    },
    listItem: {
        height: 45,
        cursor: 'pointer',
        paddingTop: 0,
        paddingBottom: 0
    },
    listItemGroup: {
        paddingLeft: '2rem'
    },
    ListExpand: {
        paddingTop: "8px",
        paddingBottom: "8px",
    }, TextGroup: {
        fontFamily: 'UniviaPro',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 2,
        letterSpacing: '0.12px',
        color: '#4f5064',
    },

}));

export default function SubItem({ children, data, onToggleExpand, onChangeNode }) {
    const translate = useTranslate();
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    const classes = useStyles();
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );
    const { expand, name, checked } = data;

    const changeSelected = (e) => {
        e.stopPropagation();
        onChangeNode(data);
    }

    const iconButtonClasses = expand ? [classes.iconButton, classes.iconButtonOpen] : [classes.iconButton, classes.iconButtonClose];
    const listItemClasses = data.nodeType === 'group' ? [classes.listItem, classes.listItemGroup] : [classes.listItem];
    return (
        <Box my={data.nodeType === 'entity' ? 2 : 0} borderRadius='0px' bgcolor={theme.palette.background.paper}   >
            <ListItem className={listItemClasses} divider={true} onClick={() => onToggleExpand(data)}>
                <ExpandButton open={expand} />
                <ListItemText primary={<Typography className={classes.TextGroup} style={{ marginLeft: '1em' }}>{name}</Typography>} />
                <CheckBox checked={checked} onClick={(e) => changeSelected(e)} />
            </ListItem>
            <Collapse in={expand} timeout="auto" unmountOnExit>
                <Box display='flex'>
                    <Box width='8px' bgcolor={blue[100]}></Box>
                    <Box bgcolor='background.paper' width='100%'>
                        <List component="div" disablePadding>
                            {children}
                        </List>
                    </Box>
                </Box>
            </Collapse>
        </Box>
    );
}
